module.exports = __webpack_public_path__ + "img/logo_light.e02d39db.svg";